export default __webpack_public_path__ + "static/media/shoplogix.31ab9a54.jpg";